export default __webpack_public_path__ + "static/media/salesforce.f36e126a.png";